import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PeriodStartDateSelector, {
  DISPLAY_VARIANT
} from '~/modules/common/charts/dashboard/PeriodStartDateSelector';
import ResourcingOverviewUnitDropDown from '~/modules/resource-management/ResourcingOverview/components/ResourcingOverviewUnitDropdown';
import PeriodDropdown from '~/modules/common/components/PeriodDropdown';
import useResourceOverviewToolbarContext from '../../hooks/useResourceManagementDashboardContext';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: 0,
    marginBottom: theme.spacing(1)
  },
  section: {
    display: 'flex',
    alignItems: 'center'
  },
  dateNavigation: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));

const useFormControlStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0, 0.5)
  }
}));

export const ResourceManagementDashboardToolbar = () => {
  const classes = useStyles();
  const formControlClasses = useFormControlStyles();

  const {
    periodScale,
    setPeriodScale,
    displayUnit,
    setDisplayUnit,
    dateRange,
    onPreviousClick,
    onNextClick,
    setDate
  } = useResourceOverviewToolbarContext();

  return (
    <div className={classes.container}>
      <div className={classes.section}>
        <PeriodStartDateSelector
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
          dateRange={dateRange}
          scale={periodScale}
          setDate={setDate}
          displayVariant={DISPLAY_VARIANT.DATE}
        />
      </div>

      <div className={classes.section}>
        <ResourcingOverviewUnitDropDown
          classes={formControlClasses}
          value={displayUnit}
          onChange={setDisplayUnit}
        />

        <PeriodDropdown
          classes={formControlClasses}
          onChange={setPeriodScale}
          value={periodScale}
          showYears={false}
          showQuarters
          showWeeks
        />
      </div>
    </div>
  );
};

export default ResourceManagementDashboardToolbar;
